<template>
    <ContentWrapper>
        <v-card>
            <v-parallax :src="require('../assets/tennisplatz.jpg')"></v-parallax>
            <v-card-text>
                Moin,
                <br><br>
                <p>
                der Ellerauer Tennisclub liegt direkt an der Krumbek im Zentrum von Ellerau, im Speckgürtel von Hamburg. Die Lage in einem Park gleich neben der Sporthalle und dem Freibad ist einzigartig und lädt dazu ein schöne Momente mit Freunden oder der Familie zu erleben.
                Heute besteht der ETC aus rund 400 Mitgliedern und verfügt über eine Anlage mit 6 Freiplätzen und einer eigenen Halle mit 2 Spielfeldern. Diese stehen für freien Spielbetrieb, Training, interne und externe Turniere sowie für Punktspiele von zur Zeit 21 Erwachsenen- und 14 Jugendmannschaften zur Verfügung.
                Ein Clubhaus sowie ein zusätzlicher Clubraum in der Halle ermöglichen einen Plausch nach dem Match sowie auch kleinere Veranstaltungen, die vom Ausschuss für Freizeitaktivitäten des ETC organisiert werden.
                    Heute ist der ETC einer der mitgliederstärksten Tennisvereine in Schleswig-Holstein. Dies hat mehrere große Vorteile, da die Größe und Offenheit eine schnelle Integration ermöglicht. Es ist sehr einfach in jeder Spielstärke und Altersklasse Spieler zu finden. Unterschiedliche Taktiken wie das Spielen gegen Serve und Volley Spieler, Bringer oder starke Aufschläger kann praktiziert werden. Und natürlich ist auch immer was los auf der Terrasse des ETC. Besonders bei Sonnenuntergang führt das zwangsläufig zu einem Urlaubsgefühl.</p>
                <br>
                <p>
                Der ETC hat sich dem Breitensport verschrieben. Mehr als 100 Kinder und Jugendliche trainieren bei ausgebildeten Trainern. Das Familienerlebnis und das Miteinander über Generationen bei der sportlichen Herausforderung oder dem anregenden Gespräch steht im Mittelpunkt.
                </p>
                <br>
                Es entspricht dem Wesen unseres Clubs, sich nicht abzugrenzen und möglichst vielen den Weg zu einem Sport zu ebnen, den man lange betreiben und auch im fortgeschrittenen Alter noch beginnen kann. Häufig starten insbesondere Leute ihre zweite Karriere nach einem Teamsport wie Fußball oder Handball beim Tennis im ETC. Die einzigartige Lage in Ellerau vertieft darüber hinaus auch die Verbundenheit zu diesem Ort.
                <p>
                Tennis ist heute ein günstiger Familiensport für Alle. Auch die Kosten für die Benutzung der Halle sind konkurrenzlos. Dieses Freizeitvergnügen ist nur möglich durch das Konzept der Selbstbewirtschaftung, dem sich der ETC verschrieben hat. Jeder packt selbst mit an, wo es notwendig ist. Das Ergebnis ist ein lebendiger Verein, der seine Herausforderungen selbst löst und auf soliden wirtschaftlichen Füßen steht.
                </p>
                <br>
                <p>
                Wir heißen Sie als Gäste oder zukünftige Mitglieder Herzlich Willkommen!
                </p>
                <br>

                <b>Das Präsidium des ETCs</b>

            </v-card-text>
        </v-card>
    </ContentWrapper>
</template>

<script>
    import ContentWrapper from '@/components/ContentWrapper'

    export default {
        name: 'Home',
        components: {
            ContentWrapper
        },
        computed: {
            history: function () {
                return this.$store.state.history
            }
        },
        created() {
            this.$store.commit('SET_TITLE', "Home")
        }
    }
</script>
